module.exports = __webpack_public_path__ + "assets/HKNova-Light.svg";


//////////////////
// WEBPACK FOOTER
// ./fonts/HKNova-Light.svg
// module id = 141
// module chunks = 0